if (!customElements.get('hot-spot-section')) {
  customElements.define(
    'hot-spot-section',
    class HotSpotSection extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.triggers = Array.from(this.querySelectorAll('[data-hot-spot-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-hot-spot-panel]'));

        if (!this.triggers.length) {
          return;
        }

        const defaultIndex = this.dataset.activeIndex || this.triggers[0].dataset.hotSpotIndex;
        this.setActive(defaultIndex);

        this.triggers.forEach((trigger) => {
          trigger.addEventListener(
            'click',
            () => {
              this.setActive(trigger.dataset.hotSpotIndex);
            },
            { signal: this.abortController.signal }
          );
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      setActive(index) {
        this.triggers.forEach((trigger) => {
          const isActive = trigger.dataset.hotSpotIndex === index;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.hotSpotIndex === index;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }
    }
  );
}